import React, { Component } from 'react';
import Raven from 'raven-js';
import { fetchUser } from './fetchUser';
import { BookingSectionView } from './BookingSection';


export class BookingSectionContainer extends Component {
    state = {
        user: null,
    };

    componentDidMount() {
        this.fetchUser();
    }

    render() {
        const props = {
            ...this.props,
            user: this.state.user,
        };
        return <BookingSectionView {...props} />;
    }

    fetchUser = async () => {
        try {
            const user = await fetchUser();
            this.setState({ user });
        } catch (err) {
            // Even when logged out, user state should be returned with login_state of 0.
            Raven.captureException(err);
        }
    }
}
